import React from 'react';
import './header.scss';

export const scrollToId = (e) => {
    const sectionParam = e.target.getAttribute('data-section');
    const section = document.getElementById(sectionParam);
    window.scroll({
        top: section.offsetTop, 
        left: 0, 
        behavior: 'smooth' 
    });
};

const Header = () => {
    return (
        <header className="header">
                <nav className="header__nav">
                    <ul>
                        <li data-aos="fade-down"><button className="header__nav-item" type="button" data-section="clients" onClick={scrollToId} aria-label="Idz do Dla kogo">Dla kogo?</button></li>
                        <li data-aos="fade-down" data-aos-delay="100"><button className="header__nav-item" type="button" data-section="icons" onClick={scrollToId} aria-label="Idz do korzyści">Korzyści</button></li>
                        <li data-aos="fade-down" data-aos-delay="200"><button className="header__nav-item" type="button" data-section="access" onClick={scrollToId} aria-label="Idz do Jak używać">Jak używać?</button></li>
                    </ul>
                </nav>
        </header>
    )
}

export default Header;